import { View } from "@react-pdf/renderer"
import TableRow from "./TableRow"
import { Tab } from "../../types/AlgoliaTypes"

interface TableItemsProps {
    data: Tab
}
export default function TableItems({data}: TableItemsProps) {
    return (
        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
            <TableRow items={data}></TableRow>
        </View>
    )
}